<template>
  <div class="mt-3" style="margin: 0 auto; max-width: 1200px;">
    <div v-if="this.error != ''">
      <v-alert type="error" v-bind="this.error" style="font-weight: bold;">{{this.error}}</v-alert>
    </div>
    <div v-if="$store.state.isUserLoggedIn" class="ml-3 mr-3">
      <a @click="adminPage">Admin Home</a>
      <span class="ml-1 mr-1">></span>

      <a>Orders</a>

      <v-row no-gutters>
        <v-col cols="12" sm="4">
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Email"
            v-model="emailSearch"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <v-btn
            class="mb-2 mt-4 ml-2"
            style="width: 100%; box-shadow: 0 0 5px rgb(150, 150, 150)"
            height="40"
            color="success"
            @click="searchEmail"
          >Filter</v-btn>
        </v-col>
        <v-col cols="12" sm="2">
          <v-btn
            class="mb-2 mt-4 ml-4"
            style="width: 100%; box-shadow: 0 0 5px rgb(150, 150, 150)"
            height="40"
            color="info"
            @click="clearSearch"
          >Clear</v-btn>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" sm="4">
          <h3>Email</h3>
        </v-col>
        <v-col cols="12" sm="4">
          <h3>Date Ordered</h3>
        </v-col>
        <v-col cols="12" sm="4">
          <h3>Shipped</h3>
        </v-col>
      </v-row>

      <div class="mt-1 mb-1" style="height: 1px; background-color: rgb(200, 200, 200);"></div>

      <div v-for="order in this.orders" :key="order.id">
        <v-row no-gutters>
          <v-col cols="12" sm="4">
            <h3 style="cursor: pointer;" @click="selectOrder(order)">{{order.email}}</h3>
          </v-col>
          <v-col cols="12" sm="4">
            <h3>{{order.createdAt}}</h3>
          </v-col>
          <v-col cols="12" sm="4">
            <h3 v-if="order.shipped">
              <v-icon color="green">mdi-check-bold</v-icon>
            </h3>
            <h3 v-if="!order.shipped">
              <v-icon>mdi-close-circle</v-icon>
            </h3>
          </v-col>
        </v-row>

        <div class="mt-1 mb-1" style="height: 1px; background-color: rgb(200, 200, 200);"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/AdminService";

export default {
  data: () => ({
    error: "",
    orders: null,
    emailSearch: ""
  }),
  async mounted() {
    try {
      const response = await AdminService.adminOrders();
      this.orders = response.data.orders;
    } catch (error) {
      // Credentials failed. Logout user and instruct them to login
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.error = error.response.data.error;
    }
  },
  methods: {
    adminPage() {
      this.$router.push("/admin");
    },
    selectOrder(order) {
      this.$store.dispatch("setSelectedOrder", order);
      this.$router.push("/adminSelectedOrder");
    },
    async searchEmail() {
      let search = {
        email: this.emailSearch
      };
      try {
        const response = await AdminService.adminOrdersEmail(search);
        this.orders = response.data.orders;
      } catch (error) {
        // Credentials failed. Logout user and instruct them to login
        this.$store.dispatch("setToken", null);
        this.$store.dispatch("setUser", null);
        this.error = error.response.data.error;
      }
    },
    async clearSearch() {
      this.emailSearch = "";
      try {
        const response = await AdminService.adminOrders();
        this.orders = response.data.orders;
      } catch (error) {
        // Credentials failed. Logout user and instruct them to login
        this.$store.dispatch("setToken", null);
        this.$store.dispatch("setUser", null);
        this.error = error.response.data.error;
      }
    }
  }
};
</script>
